import { render } from "./inputText.vue?vue&type=template&id=52a2f5e1"
import script from "./inputText.vue?vue&type=script&lang=js"
export * from "./inputText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__